<template>
  <div class="app-container">
    <el-card shadow="never">
      <div slot="header" class="header">
        <span>复制广告</span>
        <span>广告主：《{{ this.$route.query.account_name }}》&nbsp;&nbsp;<span>服务商：{{ this.$route.query.service_name }}</span></span>
      </div>
      <div class="top">
        <el-row :gutter="10">
          <el-col :span="4">
            <el-input
              v-model.trim="adqAdvertListParams.project_id"
              placeholder="请输入项目ID"
            >
              <i slot="prefix" class="el-input__icon el-icon-search" />
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model.trim="adqAdvertListParams.promotion_id"
              placeholder="请输入广告ID"
            >
              <i slot="prefix" class="el-input__icon el-icon-search" />
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model.trim="adqAdvertListParams.promotion_name"
              placeholder="请输入广告名称"
            >
              <i slot="prefix" class="el-input__icon el-icon-search" />
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model.trim="adqAdvertListParams.account_id"
              placeholder="请输入广告主ID"
            >
              <i slot="prefix" class="el-input__icon el-icon-search" />
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model.trim="adqAdvertListParams.advertiser_name"
              placeholder="请输入广告主名称"
            >
              <i slot="prefix" class="el-input__icon el-icon-search" />
            </el-input>
          </el-col>
          <!-- <el-col :span="4">
            <el-select
              v-model="adqAdvertListParams.system_status"
              placeholder="请选择"
            >
              <el-option
                v-for="item in system_statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col> -->
          <el-button type="primary" @click="fetchAdqAdvertList">搜索</el-button>
          <el-button
            type="info"
            plain
            icon="el-icon-refresh-left"
            @click="resetTencentAdqAdverList"
          >重置</el-button>
          <!-- <el-button type="success" @click="materialSyncbut">
            同步资产
          </el-button>
          <el-button
            type="success"
            :disabled="!isShow"
            @click="handleCopyTencentAdqAdver(adgroup_items, 'batch')"
          >
            批量复制
          </el-button> -->
        </el-row>
      </div>
      <div class="main">
        <el-table
          v-loading="loading"
          :data="adqAdvertList ? adqAdvertList : []"
          style="width: 100%"
          :row-class-name="'aaaa'"
          :row-key="getRowKeys"
          @select="multipleChoice"
          @select-all="multipleChoice"
        >
          <el-table-column
            type="selection"
            width="55"
            :data-index="1"
            :reserve-selection="true"
          />
          <!-- :selectable="checkSelect" -->

          <!-- <el-table-column
            prop="adgroup_name"
            label="广告名称"
            width="200"
          /> -->
          <el-table-column prop="account_id" label="广告主id" width="100" />
          <el-table-column prop="project_id" label="项目ID" width="200" />
          <el-table-column prop="advertiser_name" label="广告主名称" />
          <el-table-column prop="promotion_id" label="广告ID" width="200" />
          <el-table-column prop="promotion_name" label="广告名称" />
          <el-table-column
            prop="learning_phase"
            label="学习期状态"
            align="center"
          >
            <template scope="scope">
              {{
                scope.row.learning_phase == 'DEFAULT'
                  ? '不在学习期中'
                  : scope.row.learning_phase == 'LEARNING'
                    ? '学习中'
                    : scope.row.learning_phase == 'LEARNED'
                      ? '学习成功 '
                      : '学习失败'
              }}
            </template></el-table-column>
          <el-table-column prop="source" label="广告来源" />
          <el-table-column prop="is_comment_disable" label="广告评论" />
          <el-table-column
            prop="ad_download_status"
            label="客户端下载视频功能"
          />
          <el-table-column prop="materials_type" label="素材类型" width="100" />
          <el-table-column prop="budget" label="预算" width="100" />
          <el-table-column prop="bid" label="点击出价/展示出价" />
          <el-table-column prop="cpa_bid" label="目标转化出价/预期成本" />
          <el-table-column prop="deep_cpabid" label="深度优化出价" />
          <el-table-column prop="roi_goal" label="深度转化ROI系数" />
          <el-table-column prop="union_bid_ratio" label="穿山甲系数" />
          <el-table-column prop="union_bid" label="穿山甲出价" />
          <el-table-column prop="union_deep_cpa_bid" label="穿山甲ROI系数" />
          <el-table-column prop="7d_retention" label="七日内留存天数/天" />
          <!-- <el-table-column prop="schedule_time" label="广告的投放时段" /> -->
          <el-table-column prop="brand_info" label="品牌信息" />
          <el-table-column prop="config_id" label="配置ID" />
          <el-table-column
            prop="creative_auto_generate_switch"
            label="是否开启自动生成素材"
          />
          <el-table-column prop="learning_phase_text" label="学习期状态描述" />
          <el-table-column prop="status_text" label="广告状态描述" />
          <el-table-column prop="status_first_text" label="广告一级状态描述" />
          <el-table-column prop="opt_status_text" label="操作状态描述" />
          <!-- <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="200"
          >
            <template scope="scope">
              <el-button
                type="primary"
                @click="linkskip(scope.row)"
              >复制列表</el-button>
            </template>
          </el-table-column> -->
          <!-- <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleCopyTencentAdqAdver(scope.row)"
              >
                复制
              </el-button>
            </template>
          </el-table-column> -->
          <publicAdvertList ref="publicAdvertList" />
          <CopyAdqAdDialog
            ref="copyAdqAdDialog"
            :adgroup_ids="adgroup_ids"
            @qindian="quedian"
            @guanbi="alone = null"
          />
        </el-table>
        <PaginationRight
          :total="pageTotal"
          :page.sync="adqAdvertListParams.page"
          :limit.sync="adqAdvertListParams.page_size"
          @size-change="fetchPageSize"
          @current-change="fetchCurrentPage"
        />
      </div>
    </el-card>
    <el-dialog
      title="同步账户资产"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="700px"
      append-to-body
    >
      <accoutIdDialog ref="add" @submit="submit" />
    </el-dialog>
  </div>
</template>

<script>
import accoutIdDialog from './CopyAdqAdDialog/accoutIdDialog.vue'
import { promotionIndex, job_create, materialSync } from '@/api/customer.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import CopyAdqAdDialog from './CopyAdqAdDialog/index.vue'
import { copyAdqAdvert } from '@/api/customer/accountList/copyAdvertManage'
import publicAdvertList from '@/views/customer/accountList/tencentAdqAdvertManage/publicAdvertList'
export default {
  name: 'CopyAdqAdvertManage',
  components: {
    PaginationRight,
    publicAdvertList,
    CopyAdqAdDialog,
    accoutIdDialog
  },
  data() {
    return {
      loading: false,
      loadingGlobalWindow: false,
      pageTotal: 0,
      adqAdvertListParams: {
        project_id: null,
        promotion_id: null,
        account_id: this.$route.query.account_id || null,
        advertiser_name: null,
        promotion_name: null,
        page: 1,
        page_size: 10
      },
      adqAdvertList: null,
      adgroup_ids: null,
      alone: null,
      allow_template: null,
      adgroup_items: [],
      system_statusOptions: [
        {
          value: 'ADGROUP_STATUS_FROZEN',
          label: '已冻结'
        },
        {
          value: 'ADGROUP_STATUS_SUSPEND',
          label: '暂停中'
        },
        {
          value: 'ADGROUP_STATUS_NOT_IN_DELIVERY_TIME',
          label: '广告未到投放时间'
        },
        {
          value: 'ADGROUP_STATUS_ACTIVE',
          label: '投放中'
        },
        {
          value: 'ADGROUP_STATUS_DELETED',
          label: '已删除'
        },
        {
          value: 'ADGROUP_STATUS_ACCOUNT_BALANCE_NOT_ENOUGH',
          label: '账户余额不足'
        },
        {
          value: 'ADGROUP_STATUS_DAILY_BUDGET_REACHED',
          label: '广告达到日预算上限'
        },
        {
          value: 'ADGROUP_STATUS_PARTIAL_ACTIVE',
          label: '部分投放中'
        },
        {
          value: 'ADGROUP_STATUS_CREATIVE_STATUS_PENDING',
          label: '创意未投放'
        },
        {
          value: 'ADGROUP_STATUS_CREATIVE_EMPTY',
          label: '创意准备中'
        },
        {
          value: 'ADGROUP_STATUS_JOINT_BUDGET_REACHED',
          label: '广告被暂停（联合预算达上限）'
        }
      ],
      dialogVisible: false
    }
  },
  computed: {
    isShow() {
      let blo = false
      console.log('this.adgroup_items:', this.adgroup_items)
      if (this.adgroup_items.length !== 0) {
        const account_id = this.adgroup_items[0].account_id
        // eslint-disable-next-line eqeqeq
        const isAllAccountIdsEqual = this.adgroup_items.every(
          // eslint-disable-next-line eqeqeq
          (item) => item.account_id == account_id
        )

        if (isAllAccountIdsEqual) {
          blo = true
        } else {
          blo = false
        }
      }
      return blo
    }
  },
  created() {
    this.fetchAdqAdvertList()
    console.log(this.$route.query)
    window.aaaaa = this
  },
  methods: {
    handleCopyTencentAdqAdver(rowData, type) {
      console.log('rowDat5a:', rowData)
      // if (rowData && !this.allow_template.includes(rowData.preview_info.adcreative_template_id)) {
      //   return
      // }
      // if (!rowData) {
      //   const type = this.adgroup_items[0].promoted_object_type
      //   const newArr = this.adgroup_items.filter(item => {
      //     return item.promoted_object_type === type
      //   })

      //   var text = null
      //   if (newArr.length !== this.adgroup_items.length) {
      //     text = '目标不一致'
      //   }
      // }
      this.alone = rowData

      // this.$refs.copyAdqAdDialog.open(text || rowData || { promoted_object_type: this.adgroup_items[0].promoted_object_type })
      this.$refs.copyAdqAdDialog.open(rowData, type)
    },
    async quedian(obj, fu) {
      console.log('ob56565j888888:', obj)
      if (!this.loadingGlobalWindow) {
        this.loadingGlobalWindow = true
        try {
          const res = await job_create(obj)
          console.log('res:', res)
          this.$message.success(res.message)
          this.loadingGlobalWindow = false
          fu()
          this.fetchAdqAdvertList()
        } catch (error) {
          this.loadingGlobalWindow = false
        }
      }
    },
    fetchPageSize(e) {
      console.log('11', e)
      this.adqAdvertListParams.page_size = e
      this.fetchAdqAdvertList()
    },
    fetchCurrentPage(e) {
      console.log('22', e)
      this.adqAdvertListParams.page = e
      this.fetchAdqAdvertList()
    },
    async submit(obj, fu) {
      await materialSync(obj)
      this.$message.success('创建成功')
      setTimeout(() => {
        this.getAdvertiserList()
      }, 2 * 60 * 1000)
      this.handleClose()
      fu()
    },
    handleClose() {
      this.dialogVisible = false
    },
    materialSyncbut(row) {
      this.dialogVisible = true
      console.log(this.adqAdvertListParams.account_id)
      this.$nextTick(() => {
        // eslint-disable-next-line eqeqeq
        if (
          // eslint-disable-next-line eqeqeq
          this.$route.query.account_id == this.adqAdvertListParams.account_id
        ) {
          console.log(1)
          this.$refs.add.send(row, this.$route.query)
        } else {
          let obj = {}
          if (this.adqAdvertListParams.account_id !== '') {
            console.log(2, this.adqAdvertListParams.account_id)
            this.adqAdvertList.forEach((element) => {
              // eslint-disable-next-line eqeqeq
              if (element.account_id == this.adqAdvertListParams.account_id) {
                obj = {
                  account_id: element.account_id,
                  account_name: element.account_name
                }
              }
            })
          }
          this.$refs.add.send(row, obj)
        }
      })
    },
    linkskip(row) {
      this.$router.push({
        path: '/tencentAD/copyRecord/index',
        query: { item: row }
      })
    },
    // 获取广告列表
    fetchAdqAdvertList() {
      this.loading = true
      promotionIndex(this.adqAdvertListParams).then((res) => {
        this.adqAdvertList = res.data.list
        this.pageTotal = res.data.count

        // this.allow_template = res.data.allow_template
        // this.loadTheFirstPin(this.adqAdvertList)
        // this.pageTotal = res.data.page_info.total_number
        this.loading = false
      })
    },
    // 搜索公共广告
    searchTencentAdqAdver() {
      if (this.adqAdvertListParams.adgroup_name === '') {
        this.adqAdvertListParams.adgroup_name = null
      }
      this.adqAdvertListParams.page = 1
      this.fetchAdqAdvertList()
    },
    // 重置公共广告
    resetTencentAdqAdverList() {
      this.adqAdvertListParams = {
        project_id: null,
        promotion_id: null,
        account_id: this.$route.query.account_id || null,
        advertiser_name: null,
        promotion_name: null,
        page: 1,
        page_size: 10
      }
      this.fetchAdqAdvertList()
    },
    multipleChoice(arr) {
      console.log('arr:', arr)
      this.adgroup_ids = arr.map((item) => {
        return item.adgroup_id
      })
      this.adgroup_items = arr
    },
    async qindian(data1, func) {
      let obj = null
      // 判断是否不是批量复制
      if (this.alone) {
        obj = {
          origin: '2',
          account_id: this.$route.query.account_id,
          account_ids: data1,
          adgroup_ids: [this.alone.adgroup_id]
        }
      } else {
        obj = {
          origin: '2',
          account_id: this.$route.query.account_id,
          account_ids: data1,
          adgroup_ids: this.adgroup_ids
        }
      }
      copyAdqAdvert(obj)
        .then((data) => {
          this.$message({
            message: data.message,
            type: 'success'
          })
          func()
        })
        .catch((data) => {
          this.$message({
            message: `${data.message}`,
            type: 'error'
          })
        })
    },
    // loadTheFirstPin(list) {
    //   for (let i = 0; i < list.length; i++) {
    //     if (!list[i].preview_info.img && list[i].preview_info.video) {
    //       diyi(list[i].preview_info, list[i].preview_info.video)
    //     }
    //   }

    //   const This = this

    //   function diyi(obj, src) {
    //     var videoElement = document.createElement('video')
    //     videoElement.src = src
    //     videoElement.addEventListener('canplay', function () {
    //       var canvas = document.createElement('canvas')
    //       canvas.width = videoElement.videoWidth
    //       canvas.height = videoElement.videoHeight
    //       canvas.getContext('2d').drawImage(videoElement, 0, 0, canvas.width, canvas.height)
    //       var firstFrame = canvas.toDataURL('image/png') // 第一帧图片url
    //       This.$set(obj, 'firstStitch', firstFrame)
    //     })
    //   }
    // },
    checkSelect(row, index) {
      return this.allow_template.includes(
        row.preview_info.adcreative_template_id
      )
    },
    getRowKeys(row) {
      return row.adgroup_id
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  display: flex;
  justify-content: space-between;
}
.main {
  margin-top: 20px;
  video {
    width: 100px;
    height: 100px;
    object-fit: fill;
  }
  .shadowBox {
    display: flex;
    height: 100px;
    align-items: center;
    justify-content: center;
  }
}
.titip {
  width: 154px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 这里是超出几行省略 */
  overflow: hidden;
}
</style>
